<div class="kontainer" [class.deaktivert]="skjemakontroll().disabled" matTooltip="{{'Velg periode søket skal gjelde for'|translate}}" matTooltipPosition="after">
  <button mat-icon-button (click.stopp)="toggle()" class="aktiver-knapp">
    <mat-icon>check</mat-icon>
  </button>
  <mat-datepicker-toggle matIconPrefix [for]="periodevelger"/>
  <mat-date-range-input [rangePicker]="periodevelger">
    <input matStartDate [formControl]="skjemakontroll().controls.start" placeholder="{{'Startdato'|translate}}">
    <input matEndDate [formControl]="skjemakontroll().controls.slutt" placeholder="{{'Sluttdato'|translate}}">
  </mat-date-range-input>
  <mat-date-range-picker #periodevelger (click)="$event.stopPropagation()"/>

  <mat-select panelWidth="200" [formControl]="predefinertPeriodeKontroll" #predefinertPerioderValg>
    <mat-option value="iÅr">{{ 'I år'|translate }}</mat-option>
    <mat-option value="iFjor">{{ 'I fjor'|translate }}</mat-option>
    <mat-option value="siste1mnd">{{ 'Siste 30 dager'|translate }}</mat-option>
    <mat-option value="siste3mnd">{{ 'Siste 90 dager'|translate }}</mat-option>
    <mat-option value="siste6mnd">{{ 'Siste 180 dager'|translate }}</mat-option>
    <mat-divider/>
    <mat-option value="rangePicker">{{ 'Velg fra - til datoer'|translate }}</mat-option>
  </mat-select>
</div>
@if (skjemakontroll().disabled) {
  <div (click)="aktiver()" class="aktiver-overlay"></div>
}
